import { useAppSelector } from "@liberty-fund/data-context/hooks";
import type { AccountState } from "@liberty-fund/data-context/types";

const Profile = () => {
  const defaultPicture = "/auth0-user.png";
  const { user, roles } = useAppSelector<AccountState>(
    (state) => state.account,
  );

  if (!user) {
    return null;
  }

  return (
    <div className="my-6">
      <div className="flex">
        <div>
          <img
            src={user.picture || defaultPicture}
            alt="Profile"
            width={80}
            height={80}
          />
        </div>
        <div className="pl-4">
          <h2 className="font-bold text-lg">{user.nickname}</h2>
          <p className="">{user.email}</p>
          <p className="font-bold">Roles:</p>
          {!roles && <p>Loading roles ...</p>}
          {roles && (
            <>
              {roles?.length ? (
                <ul>
                  {roles.map((role: any, key) => (
                    <li key={key}>{role}</li>
                  ))}
                </ul>
              ) : (
                <p>You have no roles assigned.</p>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default Profile;
